import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { Component, findComponents, EventListener, getComponentByDomNode } from '@gondel/core';
import { Video } from '../../video/js/video';
import '../../video/js/video';
import { Accordion } from '../../../organisms/accordion/js/accordion';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

// add your states here, e.g. Hidden: 'state-m-video-player--hidden',
enum States {
	Hidden = 'state-m-video-teaser--hidden',
	AnimationEnd = 'state-m-video-teaser--animation-end',
}

// add your selector here, e.g. Element = '.js-m-video-player',
enum Selectors {
	PlayButton = '.js-video-teaser-button',
	TeaserWrapper = '.js-m-video-teaser__wrapper',
	TeaserVideo = '.js-m-video-teaser__video',
	Accordion = '.js-o-accordion',
}

// The @Component decorator will connect the class with `data-g-name="VideoTeaser"` elements.
@Component('VideoTeaser')
export class VideoTeaser extends GondelJqueryComponent {
	private controllers: any[] = Array();
	private videoPlayer: Video;
	private $teaserWrapper: JQuery;

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx);
		this.addTransitionEndListener();
		this.initVideoTeaser();
	}

	public start() {
		this.videoPlayer = findComponents<Video>(this._ctx, 'Video')[0];
		this.$teaserWrapper = $(Selectors.TeaserWrapper, this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}

	@EventListener('click', Selectors.PlayButton)
	public _handlePlayButtonClick(ev: MouseEvent) {
		ev.preventDefault();
		if (this.videoPlayer) {
			this.videoPlayer.initVideoPlayer();
		}

		this.$teaserWrapper.addClass(States.Hidden);
		this.showVideoWrapper();
	}

	private addTransitionEndListener() {
		this.$ctx.one('transitionend', () => {
			this.$ctx.addClass(States.AnimationEnd);
		});
	}

	private get shouldInitVideo(): boolean {
		return this.$teaserWrapper.length === 0;
	}

	private initVideoTeaser() {
		const $accordion = this.$ctx.closest(Selectors.Accordion);
		let accordion;
		if ($accordion.length > 0) {
			accordion = getComponentByDomNode<Accordion>($accordion.get(0));
		}
		if (this.shouldInitVideo) {
			if ($accordion && $accordion.length > 0) {
				accordion.registerCallback(this.initVideoPlayer, 'open', this.$ctx);
				accordion.registerCallback(this.removeVideoPlayer, 'close', this.$ctx);
			} else {
				this.videoPlayer.initVideoPlayer();
			}
			this.showVideoWrapper();
		} else {
			if ($accordion.length > 0) {
				accordion.registerCallback(this.removeVideoPlayer, 'close', this.$ctx);
			}
		}
	}

	private initVideoPlayer = async () => {
		await this.videoPlayer.initVideoPlayer();
	};

	private removeVideoPlayer = () => {
		this.$teaserWrapper.removeClass(States.Hidden);
		this.videoPlayer.removePlayer();
	};

	private showVideoWrapper = () => {
		const $teaserVideoWrapper = this.$ctx.find(Selectors.TeaserVideo);
		$teaserVideoWrapper.removeClass(States.Hidden);
	};
}
